module.exports = __webpack_public_path__ + "static/img/current-discount.3f26b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activity/full-amount-activity/current-discount.png
// module id = sL7R
// module chunks = 4